import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import {
  pagingConversionQuantityUnit,
  getConversionQuantityUnitById,
  deleteConversionQuantityUnit,
  saveConversionQuantityUnit,
} from "app/services/ConversionQuantityUnitService";

export default class ConversionQuantityUnitStore {
  listAllConversionQuantityUnit = [];
  searchConversionQuantityUnit = new SearchObject();
  pageConversionQuantityUnit = null;
  selectedConversionQuantityUnit = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteConversionQuantityUnit = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingConversionQuantityUnit = async () => {
    try {
      const res = await pagingConversionQuantityUnit(this.searchConversionQuantityUnit);
      this.pageConversionQuantityUnit = res.data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  handleChangeFormSearch = (searchConversionQuantityUnit) => {
    this.searchConversionQuantityUnit = checkSearchObject(
      this.searchConversionQuantityUnit,
      searchConversionQuantityUnit
    );
    this.pagingConversionQuantityUnit();
  };

  handleOpenFormCreateOrEdit = async (id) => {
    try {
      if (id) {
        const res = await getConversionQuantityUnitById(id);
        this.selectedConversionQuantityUnit = res.data;
        this.openFormCreateOrEdit = true;
      } else {
        this.selectedConversionQuantityUnit = {};
        this.openFormCreateOrEdit = true;
      }
    } catch (error) {
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  saveConversionQuantityUnit = async (nutraceuticals, { setSubmitting }) => {
    try {
      await saveConversionQuantityUnit(nutraceuticals);
      this.selectedConversionQuantityUnit = null;
      toast.success("Lưu thông tin đơn vị tính cần chuyển đổi thành công!");
      this.handleClosePopup();
      this.pagingConversionQuantityUnit();
      setSubmitting(false);
    } catch (error) {
      toast.error("Lưu thông tin đơn vị tính cần chuyển đổi có lỗi");
    }
  };

  handleDeleteConversionQuantityUnit = (nutraceuticals) => {
    this.selectedConversionQuantityUnit = { id: nutraceuticals.id };
    this.openConfirmDeleteConversionQuantityUnit = true;
  };

  handleConfirmDeleteConversionQuantityUnit = async () => {
    try {
      await deleteConversionQuantityUnit(this.selectedConversionQuantityUnit?.id);
      if (
        this.searchConversionQuantityUnit?.pageIndex > 1 &&
        this.searchConversionQuantityUnit?.content?.length === 1
      ) {
        this.searchConversionQuantityUnit.pageIndex -= 1;
      }
      toast.success("Xóa đơn vị tính cần chuyển đổi thành công!");
      this.handleClosePopup();
      this.pagingConversionQuantityUnit();
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteConversionQuantityUnit = false;
  };

  resetStore = () => {
    this.searchConversionQuantityUnit = new SearchObject();
    this.pageConversionQuantityUnit = null;
    this.selectedConversionQuantityUnit = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteConversionQuantityUnit = false;
  };
}
